import { Table, Typography, message } from 'antd';
import { PAGE_SIZE_OPTIONS } from 'constants/table';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import { useEffect, useState } from 'react';

import { SessionService } from 'services/SessionsService';
import { formatDate } from 'utils';

const PAGE_TITLE = 'История сессий';

function HistorySessions() {
  useDocumentTitle(PAGE_TITLE);
  useHeaderChanger(PAGE_TITLE);
  const device = {
    0: 'CRM',
    1: 'MOBILE',
    2: 'WEB',
  };

  const {
    page,
    perPage,
    totalRows,
    setPagination,
    setTotalRows,
    resetPagination,
  } = usePagination({ updateQuery: false });

  const [sessions, setSessions] = useState([]);

  const columns = [
    {
      title: 'Устройство',
      dataIndex: 'device_type',
      key: 'device_type',
      width: '70%',
      render: (id) => device[id],
    },
    {
      title: 'Дата входа',
      dataIndex: 'created_date',
      key: 'created_date',
      render: (date, rec) => {
        if (rec.is_success) {
          return formatDate(date, 'YYYY-MM-DD h:mm:ss');
        }
        return (
          <Typography.Text type="danger">
            Неудачная попытка входа
          </Typography.Text>
        );
      },
    },
    {
      title: 'Дата выхода',
      dataIndex: 'logout_date',
      key: 'logout_date',
      render: (date, rec) => {
        if (rec.is_success & !!date) {
          return formatDate(date, 'YYYY-MM-DD h:mm:ss');
        }
        if (rec.is_success & !date) {
          return <Typography.Text type="success">Активна</Typography.Text>;
        }

        return null;
      },
    },
  ];

  const fetchSessions = async () => {
    try {
      const { items, total } = await SessionService.getSessions({
        page,
        perPage,
      });
      if (items) {
        setSessions(items);
        setTotalRows(total);
      }
    } catch (error) {
      message.error(error);
    }
  };

  useEffect(() => {
    fetchSessions();
  }, [page, perPage]);

  useEffect(() => {
    return () => resetPagination();
  }, []);

  return (
    <Table
      pagination={{
        pageSize: perPage,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      dataSource={sessions}
      columns={columns}
      onChange={setPagination}
    />
  );
}

export { HistorySessions };
